module.exports = __webpack_public_path__ + "img/logo_long_small_white.747737d6.png";